module.exports = __webpack_public_path__ + "static/media/howitworks.60d77b11.png";